function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    "@swc/helpers - instanceof";
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/carousel/index.ts
var getSwipeDirection = function getSwipeDirection(activeIndex, previousIndex) {
    return activeIndex > previousIndex ? "right" : "left";
};
// src/hashEmail/index.ts
function hashEmail(email) {
    return _async_to_generator(function() {
        var data, hash;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    data = new TextEncoder().encode(email.toLowerCase().trim());
                    return [
                        4,
                        crypto.subtle.digest("SHA-256", data)
                    ];
                case 1:
                    hash = _state.sent();
                    return [
                        2,
                        Array.from(new Uint8Array(hash), function(b) {
                            return b.toString(16).padStart(2, "0");
                        }).join("")
                    ];
            }
        });
    })();
}
// src/splitTestUtils/index.ts
var PRICING_GROUP_COOKIE = "PRICING_GROUP";
var SPLIT_TEST_DIMENSION = 5;
var Environment = /* @__PURE__ */ function(Environment2) {
    Environment2["Production"] = "production";
    Environment2["Staging"] = "staging";
    return Environment2;
}(Environment || {});
var LandingSplitTestGroup = /* @__PURE__ */ function(LandingSplitTestGroup2) {
    LandingSplitTestGroup2["VariantA"] = "a";
    LandingSplitTestGroup2["VariantB"] = "b";
    LandingSplitTestGroup2["VariantC"] = "c";
    return LandingSplitTestGroup2;
}(LandingSplitTestGroup || {});
var AppSplitTestGroup = /* @__PURE__ */ function(AppSplitTestGroup2) {
    AppSplitTestGroup2[AppSplitTestGroup2["ControlGroup"] = 0] = "ControlGroup";
    AppSplitTestGroup2[AppSplitTestGroup2["TestGroup"] = 1] = "TestGroup";
    return AppSplitTestGroup2;
}(AppSplitTestGroup || {});
var SPLIT_TEST_GROUPS = {
    app: {
        0: 0 /* ControlGroup */ ,
        1: 1 /* TestGroup */ 
    },
    "landing-pages": {
        0: "a" /* VariantA */ ,
        1: "b" /* VariantB */ ,
        2: "c" /* VariantC */ 
    }
};
var simpleHashCode = function simpleHashCode(str) {
    var hash = 0;
    if (typeof str === "undefined" || str.length === 0) {
        return hash;
    }
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
    }
    return Math.abs(hash);
};
var generateRandomUserId = function generateRandomUserId() {
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var userId = "";
    for(var i = 0; i < 6; i++){
        userId += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return userId;
};
var calculateTestingGroup = function calculateTestingGroup() {
    var userId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : generateRandomUserId(), totalGroups = arguments.length > 1 ? arguments[1] : void 0;
    return simpleHashCode(userId) % totalGroups;
};
var isValidSplitTestGroup = function isValidSplitTestGroup(group, splitTestDomain) {
    if (typeof group === "undefined" || group === null) {
        return false;
    }
    return Object.values(SPLIT_TEST_GROUPS[splitTestDomain]).includes(group);
};
var getTotalSplitTestGroups = function getTotalSplitTestGroups(splitTestGroup) {
    return Object.keys(SPLIT_TEST_GROUPS[splitTestGroup]).length;
};
// src/sentry/excludes.ts
var excludes_default = [
    /.*this.createMasterFrame.*/i,
    // Chargebee
    /A network error occurred/i,
    /AbortError: AbortError/i,
    /AbortError: The user aborted a request/i,
    /Action timed out/i,
    /Already another checkout is in progress/i,
    // https://femtasy.slack.com/archives/C019K1EKG9W/p1646382410848919
    /Background Sync is disabled/i,
    /Cache.put\(\) encountered a network error/i,
    // Service Worker
    /Cancel rendering route/i,
    // https://github.com/vercel/next.js/discussions/36499
    /Cannot read properties of null \(reading '(XMLHttpRequest|then)'\)/i,
    /Cannot read properties of null \(reading 'hasConsented'\)/i,
    // https://pink-internet-gmbh.sentry.io/issues/4640481272
    /Cannot read properties of null \(reading 'domInteractive'\)/i,
    // https://pink-internet-gmbh.sentry.io/issues/4689806181
    /Child to insert before is not a child of this node/i,
    /Connection to Indexed Database server lost/i,
    /Could not mount master component/i,
    // Chargebee
    /Failed to execute .*dbankcloud.com.*/i,
    // Huawei making requests somewhere
    /checkPerfReady/i,
    // Nobody knows, https://github.com/getsentry/sentry-javascript/issues/10011#issuecomment-1919352232
    /Hydration failed|hydrating|does not match/i,
    /Invariant: attempted to hard navigate to the same URL/i,
    // https://github.com/vercel/next.js/issues/43088
    /Loading CSS chunk \d+ failed/i,
    // https://pink-internet-gmbh.sentry.io/issues/3349009581
    /Loading CSS chunk/i,
    // Loading CSS Chunks failed
    /Loading chunk/i,
    // Loading JS Chunks failed
    /Unable to preload CSS for/i,
    // Vite CSS preload failure, recovered via vite:preloadError reload (FM-9447)
    /Failed to fetch dynamically imported module/i,
    // Vite lazy chunk fetch failure, recovered via vite:preloadError reload (FM-9447)
    /error loading dynamically imported module/i,
    // Vite lazy chunk load failure, recovered via vite:preloadError reload (FM-9447)
    /Importing a module script failed/i,
    // iOS Safari/WebKit modulepreload bug, recovered via vite:preloadError reload (FM-9447)
    /Network Error/i,
    /NetworkError when attempting to fetch resource/i,
    /No error message/i,
    /NotAllowedError: Write permission denied/i,
    // Service Worker
    /Quota exceeded/i,
    /Request aborted/i,
    /Target container is not a DOM element/i,
    // React.DOM
    /The node before which the new node is to be inserted is not a child of this node/i,
    /The operation is insecure/i,
    /The operation was aborted/i,
    /Unknown error when creating the checkout session/i,
    // Chargebee
    /Unreachable hosts/i,
    // Algolia API requests
    /_AutofillCallbackHandler/i,
    // https://stackoverflow.com/questions/72720387/cant-find-variable-autofillcallbackhandler
    /berschreitung bei der Anforderung/i,
    // Request Timed Out in German
    /cb-master-frame iframe load failed/i,
    // Chargebee
    /find variable: instantSearchSDKJSBridgeClearHighlight/i,
    // https://stackoverflow.com/questions/69261499/what-is-instantsearchsdkjsbridgeclearhighlight
    /Can't find variable: webkit/i,
    // https://stackoverflow.com/questions/64922289/cant-find-variable-webkit-on-ios-14-2
    /from accessing a cross-origin frame. Protocols, domains, and ports must match/i,
    // iframe issue, found in Klaviyo integration
    /fromContainerExecution/i,
    // Google Analytics
    /getRestrictions is not a function/i,
    // We saw it from Google Analytics
    /globalThis is not defined/i,
    // Happens in old browsers. To fix it we would need a polyfill
    /is not allowed by Access-Control-Allow-Origin/i,
    /null is not an object \(evaluating 'this.window.close'\)/i,
    /null is not an object \(evaluating 't.toFixed'\)/i,
    // This error comes from i18
    /timeout exceeded/i,
    // Axios
    /undefined is not an object \(evaluating 'document.getElementsByTagName\('video'\)\[0\].webkitExitFullScreen'\)/i,
    // We don't really know, https://pink-internet-gmbh.sentry.io/issues/1543819254
    /this._logicalFormForControl\(e\).formElement/i,
    // Seems to come from a iCloud issue on ios, https://gist.github.com/AngeloD2022/fc105f77e999c024dff937f792875507
    /Attempt to iterate a cursor that doesn't exist/i,
    // Happens on ios with IndexedDB in the PWA. Potentially when is in the background. https://bugs.webkit.org/show_bug.cgi?id=235579
    /Cannot read properties of undefined \(reading '_AW-656470614'\)/i,
    // Google Analytics, seems a problem with ad blockers
    /Cannot read properties of undefined \(reading '_AW-674289998'\)/i,
    // Google Analytics, seems a problem with ad blockers
    /rejection captured with value: Object Not Found Matching Id/i,
    // According to Sentry, it is probably a Office 365 issue. Safe to ignore. https://github.com/getsentry/sentry-javascript/issues/3440
    /AutoFillPopupClose/i,
    // Not a clear idea, seems some kind of autofill issue. Safe to ignore.
    /'div:has\(\> iframe\[id='(.+)'\]\)' is not a valid selector/i
];
// src/sentry/index.ts
var isFilteredError = function isFilteredError(error, errorList) {
    if (!error) {
        return void 0;
    }
    return errorList.find(function(regex) {
        return regex.test(error);
    }) !== void 0;
};
var filterError = function filterError(event, hint) {
    var _event_exception_values, _event_exception;
    var exceptionIsFiltered = (_event_exception = event.exception) === null || _event_exception === void 0 ? void 0 : (_event_exception_values = _event_exception.values) === null || _event_exception_values === void 0 ? void 0 : _event_exception_values.find(function(exception) {
        return isFilteredError(exception.value, excludes_default);
    });
    var error = hint === null || hint === void 0 ? void 0 : hint.originalException;
    var stackIsFiltered = isFilteredError(error === null || error === void 0 ? void 0 : error.stack, excludes_default);
    if (exceptionIsFiltered || stackIsFiltered) {
        console.log("Event filtered:", event, hint);
        return null;
    }
    return event;
};
// src/time/index.ts
var secondsToMinutes = function secondsToMinutes(seconds) {
    var minutes = Math.floor(seconds / 60);
    var secs = Math.floor(seconds % 60);
    return "".concat(minutes, ":").concat(secs < 10 ? "0" : "").concat(secs);
};
// src/taboolaPixel/index.ts
var getTaboolaTracker = function getTaboolaTracker() {
    return window._tfa || [];
};
var trackTaboolaPixel = {
    trackEvent: function trackEvent(eventName) {
        getTaboolaTracker().push({
            notify: "event",
            name: eventName
        });
    }
};
// src/tracking/dataLayer.ts
var DEFAULT_EVENT_PARAMS = {
    send_to: "default"
};
var DataLayerProvider = /*#__PURE__*/ function() {
    "use strict";
    function DataLayerProvider() {
        _class_call_check(this, DataLayerProvider);
    }
    _create_class(DataLayerProvider, [
        {
            key: "sendEvent",
            value: function sendEvent(eventName, args) {
                var dryRun = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                var _args_;
                var params = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : {};
                pushToDataLayer({
                    event: "event_push",
                    event_details: buildEventDetails(eventName, params)
                }, dryRun);
            }
        },
        {
            key: "pageView",
            value: function pageView(_documentTitle, href, params) {
                var dryRun = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                pushToDataLayer({
                    event: "event_push",
                    event_details: _object_spread({
                        eventName: "page_view",
                        pageUrl: href
                    }, params)
                }, dryRun);
            }
        },
        {
            key: "identify",
            value: function identify(_userId) {
                var _dryRun = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                return;
            }
        }
    ]);
    return DataLayerProvider;
}();
var buildEventDetails = function buildEventDetails(eventName, params) {
    switch(eventName){
        case "audio":
            return {
                eventName: eventName,
                audioAction: params.audioAction,
                audioName: params.audioName,
                audioUrl: params.audioUrl,
                audioSpeaker: params.audioSpeaker,
                audioType: params.audioType,
                pageUrl: params.pageUrl
            };
        case "cancel_subscription":
            return _object_spread({
                eventName: eventName
            }, params);
        default:
            return _object_spread({
                eventName: eventName
            }, params, DEFAULT_EVENT_PARAMS);
    }
};
var pushToDataLayer = function pushToDataLayer(payload, dryRun) {
    if (dryRun) {
        console.log("dataLayer push:", payload);
        return;
    }
    if (typeof window !== "undefined") {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    }
};
// src/tracking/gtag.ts
var GtagProvider = /*#__PURE__*/ function() {
    "use strict";
    function GtagProvider() {
        _class_call_check(this, GtagProvider);
    }
    _create_class(GtagProvider, [
        {
            key: "sendEvent",
            value: function sendEvent(eventName, args) {
                var dryRun = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                pushToGtag("event", [
                    eventName,
                    args[0]
                ], dryRun);
            }
        },
        {
            key: "pageView",
            value: function pageView(documentTitle, href, params) {
                var dryRun = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                var gaParams = Object.assign({
                    page_title: documentTitle,
                    page_path: href || window.location.pathname
                }, params);
                pushToGtag("set", [
                    gaParams
                ], dryRun);
                pushToGtag("event", [
                    "page_view",
                    getEventParams()
                ], dryRun);
            }
        },
        {
            key: "identify",
            value: function identify(userId) {
                var dryRun = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                pushToGtag("set", [
                    {
                        user_id: userId
                    }
                ], dryRun);
                pushToGtag("event", [
                    "login",
                    getEventParams()
                ], dryRun);
            }
        }
    ]);
    return GtagProvider;
}();
var pushToGtag = function pushToGtag(command, args, dryRun) {
    if (dryRun) {
        var _console;
        (_console = console).log.apply(_console, [
            "gtag:",
            command
        ].concat(_to_consumable_array(args)));
        return;
    }
    if (window.gtag) {
        var _window;
        (_window = window).gtag.apply(_window, [
            command
        ].concat(_to_consumable_array(args)));
    }
};
var getEventParams = function getEventParams() {
    return {
        send_to: "default"
    };
};
// ../../node_modules/@sentry/utils/esm/is.js
var objectToString = Object.prototype.toString;
function isError(wat) {
    switch(objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, className) {
    return objectToString.call(wat) === "[object ".concat(className, "]");
}
function isErrorEvent(wat) {
    return isBuiltin(wat, "ErrorEvent");
}
function isDOMError(wat) {
    return isBuiltin(wat, "DOMError");
}
function isDOMException(wat) {
    return isBuiltin(wat, "DOMException");
}
function isString(wat) {
    return isBuiltin(wat, "String");
}
function isParameterizedString(wat) {
    return (typeof wat === "undefined" ? "undefined" : _type_of(wat)) === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function isPrimitive(wat) {
    return wat === null || isParameterizedString(wat) || (typeof wat === "undefined" ? "undefined" : _type_of(wat)) !== "object" && typeof wat !== "function";
}
function isPlainObject(wat) {
    return isBuiltin(wat, "Object");
}
function isEvent(wat) {
    return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
function isElement(wat) {
    return typeof Element !== "undefined" && isInstanceOf(wat, Element);
}
function isRegExp(wat) {
    return isBuiltin(wat, "RegExp");
}
function isThenable(wat) {
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function isNaN2(wat) {
    return typeof wat === "number" && wat !== wat;
}
function isInstanceOf(wat, base) {
    try {
        return _instanceof(wat, base);
    } catch (_e) {
        return false;
    }
}
function isVueViewModel(wat) {
    return !!((typeof wat === "undefined" ? "undefined" : _type_of(wat)) === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
// ../../node_modules/@sentry/utils/esm/string.js
function truncate(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== "string" || max === 0) {
        return str;
    }
    return str.length <= max ? str : "".concat(str.slice(0, max), "...");
}
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return "";
    }
    var output = [];
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            if (isVueViewModel(value)) {
                output.push("[VueViewModel]");
            } else {
                output.push(String(value));
            }
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
function isMatchingPattern(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!isString(value)) {
        return false;
    }
    if (isRegExp(pattern)) {
        return pattern.test(value);
    }
    if (isString(pattern)) {
        return requireExactStringMatch ? value === pattern : value.includes(pattern);
    }
    return false;
}
function stringMatchesSomePattern(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return patterns.some(function(pattern) {
        return isMatchingPattern(testString, pattern, requireExactStringMatch);
    });
}
// ../../node_modules/@sentry/utils/esm/aggregate-errors.js
function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser) {
    var maxValueLimit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 250, key = arguments.length > 3 ? arguments[3] : void 0, limit = arguments.length > 4 ? arguments[4] : void 0, event = arguments.length > 5 ? arguments[5] : void 0, hint = arguments.length > 6 ? arguments[6] : void 0;
    if (!event.exception || !event.exception.values || !hint || !isInstanceOf(hint.originalException, Error)) {
        return;
    }
    var originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
    if (originalException) {
        event.exception.values = truncateAggregateExceptions(aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
    }
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) {
        return prevExceptions;
    }
    var newExceptions = _to_consumable_array(prevExceptions);
    if (isInstanceOf(error[key], Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        var newException = exceptionFromErrorImplementation(parser, error[key]);
        var newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException
        ].concat(_to_consumable_array(newExceptions)), newException, newExceptionId);
    }
    if (Array.isArray(error.errors)) {
        error.errors.forEach(function(childError, i) {
            if (isInstanceOf(childError, Error)) {
                applyExceptionGroupFieldsForParentException(exception, exceptionId);
                var newException = exceptionFromErrorImplementation(parser, childError);
                var newExceptionId = newExceptions.length;
                applyExceptionGroupFieldsForChildException(newException, "errors[".concat(i, "]"), newExceptionId, exceptionId);
                newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                    newException
                ].concat(_to_consumable_array(newExceptions)), newException, newExceptionId);
            }
        });
    }
    return newExceptions;
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = _object_spread_props(_object_spread({}, exception.mechanism, exception.type === "AggregateError" && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = _object_spread_props(_object_spread({}, exception.mechanism), {
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}
function truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map(function(exception) {
        if (exception.value) {
            exception.value = truncate(exception.value, maxValueLength);
        }
        return exception;
    });
}
// ../../node_modules/@sentry/utils/esm/worldwide.js
function isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : void 0;
}
var GLOBAL_OBJ = (typeof globalThis === "undefined" ? "undefined" : _type_of(globalThis)) == "object" && isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
(typeof window === "undefined" ? "undefined" : _type_of(window)) == "object" && isGlobalObj(window) || (typeof self === "undefined" ? "undefined" : _type_of(self)) == "object" && isGlobalObj(self) || (typeof global === "undefined" ? "undefined" : _type_of(global)) == "object" && isGlobalObj(global) || /* @__PURE__ */ function() {
    return this;
}() || {};
function getGlobalObject() {
    return GLOBAL_OBJ;
}
function getGlobalSingleton(name, creator, obj) {
    var gbl = obj || GLOBAL_OBJ;
    var __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
// ../../node_modules/@sentry/utils/esm/browser.js
var WINDOW = getGlobalObject();
var DEFAULT_MAX_STRING_LENGTH = 80;
function htmlTreeAsString(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) {
        return "<unknown>";
    }
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return "";
    }
    if (WINDOW.HTMLElement) {
        if (_instanceof(elem, HTMLElement) && elem.dataset && elem.dataset["sentryComponent"]) {
            return elem.dataset["sentryComponent"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function(keyAttrPair) {
            out.push("[".concat(keyAttrPair[0], '="').concat(keyAttrPair[1], '"]'));
        });
    } else {
        if (elem.id) {
            out.push("#".concat(elem.id));
        }
        className = elem.className;
        if (className && isString(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++){
                out.push(".".concat(classes[i]));
            }
        }
    }
    var allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[".concat(key, '="').concat(attr, '"]'));
        }
    }
    return out.join("");
}
function getLocationHref() {
    try {
        return WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
function getComponentName(elem) {
    if (!WINDOW.HTMLElement) {
        return null;
    }
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    for(var i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) {
            return null;
        }
        if (_instanceof(currentElem, HTMLElement) && currentElem.dataset["sentryComponent"]) {
            return currentElem.dataset["sentryComponent"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}
// ../../node_modules/@sentry/utils/esm/debug-build.js
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
// ../../node_modules/@sentry/utils/esm/logger.js
var PREFIX = "Sentry Logger ";
var CONSOLE_LEVELS = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
var originalConsoleMethods = {};
function consoleSandbox(callback) {
    if (!("console" in GLOBAL_OBJ)) {
        return callback();
    }
    var console2 = GLOBAL_OBJ.console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys(originalConsoleMethods);
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = originalConsoleMethods[level];
        wrappedFuncs[level] = console2[level];
        console2[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        wrappedLevels.forEach(function(level) {
            console2[level] = wrappedFuncs[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger2 = {
        enable: function enable() {
            enabled = true;
        },
        disable: function disable() {
            enabled = false;
        },
        isEnabled: function isEnabled() {
            return enabled;
        }
    };
    if (DEBUG_BUILD) {
        CONSOLE_LEVELS.forEach(function(name) {
            logger2[name] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                if (enabled) {
                    consoleSandbox(function() {
                        var _GLOBAL_OBJ_console;
                        (_GLOBAL_OBJ_console = GLOBAL_OBJ.console)[name].apply(_GLOBAL_OBJ_console, [
                            "".concat(PREFIX, "[").concat(name, "]:")
                        ].concat(_to_consumable_array(args)));
                    });
                }
            };
        });
    } else {
        CONSOLE_LEVELS.forEach(function(name) {
            logger2[name] = function() {
                return void 0;
            };
        });
    }
    return logger2;
}
var logger = makeLogger();
// ../../node_modules/@sentry/utils/esm/object.js
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    if (typeof wrapped === "function") {
        markFunctionWrapped(wrapped, original);
    }
    source[name] = wrapped;
}
function addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        DEBUG_BUILD && logger.log('Failed to add non-enumerable property "'.concat(name, '" to object'), obj);
    }
}
function markFunctionWrapped(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        addNonEnumerableProperty(wrapped, "__sentry_original__", original);
    } catch (o_O) {}
}
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
function convertToPlainObject(value) {
    if (isError(value)) {
        return _object_spread({
            message: value.message,
            name: value.name,
            stack: value.stack
        }, getOwnProperties(value));
    } else if (isEvent(value)) {
        var newObj = _object_spread({
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget)
        }, getOwnProperties(value));
        if (typeof CustomEvent !== "undefined" && isInstanceOf(value, CustomEvent)) {
            newObj.detail = value.detail;
        }
        return newObj;
    } else {
        return value;
    }
}
function serializeEventTarget(target) {
    try {
        return isElement(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
function getOwnProperties(obj) {
    if ((typeof obj === "undefined" ? "undefined" : _type_of(obj)) === "object" && obj !== null) {
        var extractedProps = {};
        for(var property in obj){
            if (Object.prototype.hasOwnProperty.call(obj, property)) {
                extractedProps[property] = obj[property];
            }
        }
        return extractedProps;
    } else {
        return {};
    }
}
function extractExceptionKeysForMessage(exception) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40;
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) {
        return "[object has no keys]";
    }
    if (keys[0].length >= maxLength) {
        return truncate(keys[0], maxLength);
    }
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return truncate(serialized, maxLength);
    }
    return "";
}
function dropUndefinedKeys(inputValue) {
    var memoizationMap = /* @__PURE__ */ new Map();
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    if (isPojo(inputValue)) {
        var memoVal = memoizationMap.get(inputValue);
        if (memoVal !== void 0) {
            return memoVal;
        }
        var returnValue = {};
        memoizationMap.set(inputValue, returnValue);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(inputValue)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (typeof inputValue[key] !== "undefined") {
                    returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        var memoVal1 = memoizationMap.get(inputValue);
        if (memoVal1 !== void 0) {
            return memoVal1;
        }
        var returnValue1 = [];
        memoizationMap.set(inputValue, returnValue1);
        inputValue.forEach(function(item) {
            returnValue1.push(_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue1;
    }
    return inputValue;
}
function isPojo(input) {
    if (!isPlainObject(input)) {
        return false;
    }
    try {
        var name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
// ../../node_modules/@sentry/utils/esm/stacktrace.js
var defaultFunctionName = "<anonymous>";
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== "function") {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    } catch (e) {
        return defaultFunctionName;
    }
}
// ../../node_modules/@sentry/utils/esm/instrument/_handlers.js
var handlers = {};
var instrumented = {};
function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
function maybeInstrument(type, instrumentFn) {
    if (!instrumented[type]) {
        instrumentFn();
        instrumented[type] = true;
    }
}
function triggerHandlers(type, data) {
    var typeHandlers = type && handlers[type];
    if (!typeHandlers) {
        return;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                DEBUG_BUILD && logger.error("Error while triggering instrumentation handler.\nType: ".concat(type, "\nName: ").concat(getFunctionName(handler), "\nError:"), e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
// ../../node_modules/@sentry/utils/esm/instrument/console.js
function addConsoleInstrumentationHandler(handler) {
    var type = "console";
    addHandler(type, handler);
    maybeInstrument(type, instrumentConsole);
}
function instrumentConsole() {
    if (!("console" in GLOBAL_OBJ)) {
        return;
    }
    CONSOLE_LEVELS.forEach(function(level) {
        if (!(level in GLOBAL_OBJ.console)) {
            return;
        }
        fill(GLOBAL_OBJ.console, level, function(originalConsoleMethod) {
            originalConsoleMethods[level] = originalConsoleMethod;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var handlerData = {
                    args: args,
                    level: level
                };
                triggerHandlers("console", handlerData);
                var log = originalConsoleMethods[level];
                log && log.apply(GLOBAL_OBJ.console, args);
            };
        });
    });
}
// ../../node_modules/@sentry/utils/esm/misc.js
function uuid4() {
    var gbl = GLOBAL_OBJ;
    var crypto2 = gbl.crypto || gbl.msCrypto;
    var getRandomByte = function getRandomByte() {
        return Math.random() * 16;
    };
    try {
        if (crypto2 && crypto2.randomUUID) {
            return crypto2.randomUUID().replace(/-/g, "");
        }
        if (crypto2 && crypto2.getRandomValues) {
            getRandomByte = function getRandomByte() {
                var typedArray = new Uint8Array(1);
                crypto2.getRandomValues(typedArray);
                return typedArray[0];
            };
        }
    } catch (_) {}
    return ("10000000100040008000" + 1e11).replace(/[018]/g, function(c) {
        return(// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
    });
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : void 0;
}
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return "".concat(firstException.type, ": ").concat(firstException.value);
        }
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) {
        firstException.value = value || "";
    }
    if (!firstException.type) {
        firstException.type = type || "Error";
    }
}
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = _object_spread({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = _object_spread({}, currentMechanism && currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
function arrayify(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}
// ../../node_modules/@sentry/utils/esm/instrument/dom.js
var WINDOW2 = GLOBAL_OBJ;
var DEBOUNCE_DURATION = 1e3;
var debounceTimerID;
var lastCapturedEventType;
var lastCapturedEventTargetId;
function addClickKeypressInstrumentationHandler(handler) {
    var type = "dom";
    addHandler(type, handler);
    maybeInstrument(type, instrumentDOM);
}
function instrumentDOM() {
    if (!WINDOW2.document) {
        return;
    }
    var triggerDOMHandler = triggerHandlers.bind(null, "dom");
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    WINDOW2.document.addEventListener("click", globalDOMEventHandler, false);
    WINDOW2.document.addEventListener("keypress", globalDOMEventHandler, false);
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        var proto = WINDOW2[target] && WINDOW2[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) {
            return;
        }
        fill(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") {
                    try {
                        var el = this;
                        var handlers2 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers2[type] = handlers2[type] || {
                            refCount: 0
                        };
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount++;
                    } catch (e) {}
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        fill(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") {
                    try {
                        var el = this;
                        var handlers2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers2[type];
                        if (handlerForType) {
                            handlerForType.refCount--;
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = void 0;
                                delete handlers2[type];
                            }
                            if (Object.keys(handlers2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    } catch (e) {}
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
function isSimilarToLastCapturedEvent(event) {
    if (event.type !== lastCapturedEventType) {
        return false;
    }
    try {
        if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) {
            return false;
        }
    } catch (e) {}
    return true;
}
function shouldSkipDOMEvent(eventType, target) {
    if (eventType !== "keypress") {
        return false;
    }
    if (!target || !target.tagName) {
        return true;
    }
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
        return false;
    }
    return true;
}
function makeDOMEventHandler(handler) {
    var globalListener = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function(event) {
        if (!event || event["_sentryCaptured"]) {
            return;
        }
        var target = getEventTarget(event);
        if (shouldSkipDOMEvent(event.type, target)) {
            return;
        }
        addNonEnumerableProperty(event, "_sentryCaptured", true);
        if (target && !target._sentryId) {
            addNonEnumerableProperty(target, "_sentryId", uuid4());
        }
        var name = event.type === "keypress" ? "input" : event.type;
        if (!isSimilarToLastCapturedEvent(event)) {
            var handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            lastCapturedEventType = event.type;
            lastCapturedEventTargetId = target ? target._sentryId : void 0;
        }
        clearTimeout(debounceTimerID);
        debounceTimerID = WINDOW2.setTimeout(function() {
            lastCapturedEventTargetId = void 0;
            lastCapturedEventType = void 0;
        }, DEBOUNCE_DURATION);
    };
}
function getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        return null;
    }
}
// ../../node_modules/@sentry/utils/esm/supports.js
var WINDOW3 = getGlobalObject();
function supportsFetch() {
    if (!("fetch" in WINDOW3)) {
        return false;
    }
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function supportsNativeFetch() {
    if (typeof EdgeRuntime === "string") {
        return true;
    }
    if (!supportsFetch()) {
        return false;
    }
    if (isNativeFetch(WINDOW3.fetch)) {
        return true;
    }
    var result = false;
    var doc = WINDOW3.document;
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement("iframe");
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        } catch (err) {
            DEBUG_BUILD && logger.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
        }
    }
    return result;
}
// ../../node_modules/@sentry/utils/esm/instrument/fetch.js
function addFetchInstrumentationHandler(handler) {
    var type = "fetch";
    addHandler(type, handler);
    maybeInstrument(type, instrumentFetch);
}
function instrumentFetch() {
    if (!supportsNativeFetch()) {
        return;
    }
    fill(GLOBAL_OBJ, "fetch", function(originalFetch) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _parseFetchArgs = parseFetchArgs(args), method = _parseFetchArgs.method, url = _parseFetchArgs.url;
            var handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            triggerHandlers("fetch", _object_spread({}, handlerData));
            return originalFetch.apply(GLOBAL_OBJ, args).then(function(response) {
                var finishedHandlerData = _object_spread_props(_object_spread({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                });
                triggerHandlers("fetch", finishedHandlerData);
                return response;
            }, function(error) {
                var erroredHandlerData = _object_spread_props(_object_spread({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                });
                triggerHandlers("fetch", erroredHandlerData);
                throw error;
            });
        };
    });
}
function hasProp(obj, prop) {
    return !!obj && (typeof obj === "undefined" ? "undefined" : _type_of(obj)) === "object" && !!obj[prop];
}
function getUrlFromResource(resource) {
    if (typeof resource === "string") {
        return resource;
    }
    if (!resource) {
        return "";
    }
    if (hasProp(resource, "url")) {
        return resource.url;
    }
    if (resource.toString) {
        return resource.toString();
    }
    return "";
}
function parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) {
        return {
            method: "GET",
            url: ""
        };
    }
    if (fetchArgs.length === 2) {
        var _fetchArgs = _sliced_to_array(fetchArgs, 2), url = _fetchArgs[0], options = _fetchArgs[1];
        return {
            url: getUrlFromResource(url),
            method: hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    var arg = fetchArgs[0];
    return {
        url: getUrlFromResource(arg),
        method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
// ../../node_modules/@sentry/utils/esm/instrument/globalError.js
var _oldOnErrorHandler = null;
function addGlobalErrorInstrumentationHandler(handler) {
    var type = "error";
    addHandler(type, handler);
    maybeInstrument(type, instrumentError);
}
function instrumentError() {
    _oldOnErrorHandler = GLOBAL_OBJ.onerror;
    GLOBAL_OBJ.onerror = function(msg, url, line, column, error) {
        var handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        triggerHandlers("error", handlerData);
        if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
    GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ = true;
}
// ../../node_modules/@sentry/utils/esm/instrument/globalUnhandledRejection.js
var _oldOnUnhandledRejectionHandler = null;
function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    var type = "unhandledrejection";
    addHandler(type, handler);
    maybeInstrument(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = GLOBAL_OBJ.onunhandledrejection;
    GLOBAL_OBJ.onunhandledrejection = function(e) {
        var handlerData = e;
        triggerHandlers("unhandledrejection", handlerData);
        if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
    GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
// ../../node_modules/@sentry/utils/esm/vendor/supportsHistory.js
var WINDOW4 = getGlobalObject();
function supportsHistory() {
    var chromeVar = WINDOW4.chrome;
    var isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    var hasHistoryApi = "history" in WINDOW4 && !!WINDOW4.history.pushState && !!WINDOW4.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
// ../../node_modules/@sentry/utils/esm/instrument/history.js
var WINDOW5 = GLOBAL_OBJ;
var lastHref;
function addHistoryInstrumentationHandler(handler) {
    var type = "history";
    addHandler(type, handler);
    maybeInstrument(type, instrumentHistory);
}
function instrumentHistory() {
    if (!supportsHistory()) {
        return;
    }
    var oldOnPopState = WINDOW5.onpopstate;
    WINDOW5.onpopstate = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var to = WINDOW5.location.href;
        var from = lastHref;
        lastHref = to;
        var handlerData = {
            from: from,
            to: to
        };
        triggerHandlers("history", handlerData);
        if (oldOnPopState) {
            try {
                return oldOnPopState.apply(this, args);
            } catch (_oO) {}
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args.length > 2 ? args[2] : void 0;
            if (url) {
                var from = lastHref;
                var to = String(url);
                lastHref = to;
                var handlerData = {
                    from: from,
                    to: to
                };
                triggerHandlers("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    fill(WINDOW5.history, "pushState", historyReplacementFunction);
    fill(WINDOW5.history, "replaceState", historyReplacementFunction);
}
// ../../node_modules/@sentry/utils/esm/instrument/xhr.js
var WINDOW6 = GLOBAL_OBJ;
var SENTRY_XHR_DATA_KEY = "__sentry_xhr_v3__";
function addXhrInstrumentationHandler(handler) {
    var type = "xhr";
    addHandler(type, handler);
    maybeInstrument(type, instrumentXHR);
}
function instrumentXHR() {
    if (!WINDOW6.XMLHttpRequest) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    fill(xhrproto, "open", function(originalOpen) {
        return function() {
            var _this = this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var startTimestamp = Date.now();
            var method = isString(args[0]) ? args[0].toUpperCase() : void 0;
            var url = parseUrl(args[1]);
            if (!method || !url) {
                return originalOpen.apply(this, args);
            }
            this[SENTRY_XHR_DATA_KEY] = {
                method: method,
                url: url,
                request_headers: {}
            };
            if (method === "POST" && url.match(/sentry_key/)) {
                this.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function onreadystatechangeHandler() {
                var xhrInfo = _this[SENTRY_XHR_DATA_KEY];
                if (!xhrInfo) {
                    return;
                }
                if (_this.readyState === 4) {
                    try {
                        xhrInfo.status_code = _this.status;
                    } catch (e) {}
                    var handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: _this
                    };
                    triggerHandlers("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") {
                fill(this, "onreadystatechange", function(original) {
                    return function() {
                        for(var _len = arguments.length, readyStateArgs = new Array(_len), _key = 0; _key < _len; _key++){
                            readyStateArgs[_key] = arguments[_key];
                        }
                        onreadystatechangeHandler();
                        return original.apply(this, readyStateArgs);
                    };
                });
            } else {
                this.addEventListener("readystatechange", onreadystatechangeHandler);
            }
            fill(this, "setRequestHeader", function(original) {
                return function() {
                    for(var _len = arguments.length, setRequestHeaderArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        setRequestHeaderArgs[_key] = arguments[_key];
                    }
                    var _setRequestHeaderArgs = _sliced_to_array(setRequestHeaderArgs, 2), header = _setRequestHeaderArgs[0], value = _setRequestHeaderArgs[1];
                    var xhrInfo = this[SENTRY_XHR_DATA_KEY];
                    if (xhrInfo && isString(header) && isString(value)) {
                        xhrInfo.request_headers[header.toLowerCase()] = value;
                    }
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    fill(xhrproto, "send", function(originalSend) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var sentryXhrData = this[SENTRY_XHR_DATA_KEY];
            if (!sentryXhrData) {
                return originalSend.apply(this, args);
            }
            if (args[0] !== void 0) {
                sentryXhrData.body = args[0];
            }
            var handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            triggerHandlers("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function parseUrl(url) {
    if (isString(url)) {
        return url;
    }
    try {
        return url.toString();
    } catch (e2) {}
    return void 0;
}
// ../../node_modules/@sentry/utils/esm/memo.js
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === "function";
    var inner = hasWeakSet ? /* @__PURE__ */ new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        } else {
            for(var i = 0; i < inner.length; i++){
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}
// ../../node_modules/@sentry/utils/esm/normalize.js
function normalize(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    try {
        return visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (".concat(err, ")")
        };
    }
}
function normalizeToSize(object) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100 * 1024;
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return normalized;
}
function visit(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : memoBuilder();
    var _memo = _sliced_to_array(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value === "undefined" ? "undefined" : _type_of(value)) && !isNaN2(value)) {
        return value;
    }
    var stringified = stringifyValue(key, value);
    if (!stringified.startsWith("[object ")) {
        return stringified;
    }
    if (value["__sentry_skip_normalization__"]) {
        return value;
    }
    var remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    if (remainingDepth === 0) {
        return stringified.replace("object ", "");
    }
    if (memoize(value)) {
        return "[Circular ~]";
    }
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") {
        try {
            var jsonValue = valueWithToJSON.toJSON();
            return visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
        } catch (err) {}
    }
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    var visitable = convertToPlainObject(value);
    for(var visitKey in visitable){
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
            continue;
        }
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    unmemoize(value);
    return normalized;
}
function stringifyValue(key, value) {
    try {
        if (key === "domain" && value && (typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && value._events) {
            return "[Domain]";
        }
        if (key === "domainEmitter") {
            return "[DomainEmitter]";
        }
        if (typeof global !== "undefined" && value === global) {
            return "[Global]";
        }
        if (typeof window !== "undefined" && value === window) {
            return "[Window]";
        }
        if (typeof document !== "undefined" && value === document) {
            return "[Document]";
        }
        if (isVueViewModel(value)) {
            return "[VueViewModel]";
        }
        if (isSyntheticEvent(value)) {
            return "[SyntheticEvent]";
        }
        if (typeof value === "number" && value !== value) {
            return "[NaN]";
        }
        if (typeof value === "function") {
            return "[Function: ".concat(getFunctionName(value), "]");
        }
        if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "symbol") {
            return "[".concat(String(value), "]");
        }
        if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "bigint") {
            return "[BigInt: ".concat(String(value), "]");
        }
        var objName = getConstructorName(value);
        if (/^HTML(\w*)Element$/.test(objName)) {
            return "[HTMLElement: ".concat(objName, "]");
        }
        return "[object ".concat(objName, "]");
    } catch (err) {
        return "**non-serializable** (".concat(err, ")");
    }
}
function getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
function utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
// ../../node_modules/@sentry/utils/esm/syncpromise.js
var States;
(function(States2) {
    var PENDING = 0;
    States2[States2["PENDING"] = PENDING] = "PENDING";
    var RESOLVED = 1;
    States2[States2["RESOLVED"] = RESOLVED] = "RESOLVED";
    var REJECTED = 2;
    States2[States2["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));
var SyncPromise = /*#__PURE__*/ function() {
    "use strict";
    function _SyncPromise(executor) {
        _class_call_check(this, _SyncPromise);
        _SyncPromise.prototype.__init.call(this);
        _SyncPromise.prototype.__init2.call(this);
        _SyncPromise.prototype.__init3.call(this);
        _SyncPromise.prototype.__init4.call(this);
        this._state = States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    _create_class(_SyncPromise, [
        {
            /** JSDoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new _SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) {
                                resolve(result);
                            } else {
                                try {
                                    resolve(onfulfilled(result));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                        },
                        function(reason) {
                            if (!onrejected) {
                                reject(reason);
                            } else {
                                try {
                                    resolve(onrejected(reason));
                                } catch (e) {
                                    reject(e);
                                }
                            }
                        }
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** JSDoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** JSDoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new _SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) {
                            onfinally();
                        }
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) {
                            onfinally();
                        }
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** JSDoc */ key: "__init",
            value: function __init() {
                var _this = this;
                this._resolve = function(value) {
                    _this._setResult(States.RESOLVED, value);
                };
            }
        },
        {
            /** JSDoc */ key: "__init2",
            value: function __init2() {
                var _this = this;
                this._reject = function(reason) {
                    _this._setResult(States.REJECTED, reason);
                };
            }
        },
        {
            /** JSDoc */ key: "__init3",
            value: function __init3() {
                var _this = this;
                this._setResult = function(state, value) {
                    if (_this._state !== States.PENDING) {
                        return;
                    }
                    if (isThenable(value)) {
                        void value.then(_this._resolve, _this._reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
            }
        },
        {
            /** JSDoc */ key: "__init4",
            value: function __init4() {
                var _this = this;
                this._executeHandlers = function() {
                    if (_this._state === States.PENDING) {
                        return;
                    }
                    var cachedHandlers = _this._handlers.slice();
                    _this._handlers = [];
                    cachedHandlers.forEach(function(handler) {
                        if (handler[0]) {
                            return;
                        }
                        if (_this._state === States.RESOLVED) {
                            handler[1](_this._value);
                        }
                        if (_this._state === States.REJECTED) {
                            handler[2](_this._value);
                        }
                        handler[0] = true;
                    });
                };
            }
        }
    ]);
    return _SyncPromise;
}();
// ../../node_modules/@sentry/utils/esm/url.js
function parseUrl2(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
// ../../node_modules/@sentry/utils/esm/severity.js
var validSeverityLevels = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
function severityLevelFromString(level) {
    return level === "warn" ? "warning" : validSeverityLevels.includes(level) ? level : "log";
}
// ../../node_modules/@sentry/utils/esm/time.js
var ONE_SECOND_IN_MS = 1e3;
function dateTimestampInSeconds() {
    return Date.now() / ONE_SECOND_IN_MS;
}
function createUnixTimestampInSecondsFunc() {
    var performance = GLOBAL_OBJ.performance;
    if (!performance || !performance.now) {
        return dateTimestampInSeconds;
    }
    var approxStartingTimeOrigin = Date.now() - performance.now();
    var timeOrigin = performance.timeOrigin == void 0 ? approxStartingTimeOrigin : performance.timeOrigin;
    return function() {
        return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
    };
}
var timestampInSeconds = createUnixTimestampInSecondsFunc();
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    var performance = GLOBAL_OBJ.performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return void 0;
    }
    var threshold = 3600 * 1e3;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
}();
// ../../node_modules/@sentry/utils/esm/eventbuilder.js
function parseStackFrames(stackParser, error) {
    return stackParser(error.stack || "", 1);
}
function exceptionFromError(stackParser, error) {
    var exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    var frames = parseStackFrames(stackParser, error);
    if (frames.length) {
        exception.stacktrace = {
            frames: frames
        };
    }
    return exception;
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/debug-build.js
var DEBUG_BUILD2 = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/constants.js
var DEFAULT_ENVIRONMENT = "production";
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/eventProcessors.js
function getGlobalEventProcessors() {
    return getGlobalSingleton("globalEventProcessors", function() {
        return [];
    });
}
function notifyEventProcessors(processors, event, hint) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return new SyncPromise(function(resolve, reject) {
        var processor = processors[index];
        if (event === null || typeof processor !== "function") {
            resolve(event);
        } else {
            var result = processor(_object_spread({}, event), hint);
            DEBUG_BUILD2 && processor.id && result === null && logger.log('Event processor "'.concat(processor.id, '" dropped event'));
            if (isThenable(result)) {
                void result.then(function(final) {
                    return notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
            } else {
                void notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        }
    });
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/session.js
function makeSession(context) {
    var startingTime = timestampInSeconds();
    var session = {
        sid: uuid4(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: function toJSON() {
            return sessionToJSON(session);
        }
    };
    if (context) {
        updateSession(session, context);
    }
    return session;
}
function updateSession(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) {
            session.ipAddress = context.user.ip_address;
        }
        if (!session.did && !context.did) {
            session.did = context.user.id || context.user.email || context.user.username;
        }
    }
    session.timestamp = context.timestamp || timestampInSeconds();
    if (context.abnormal_mechanism) {
        session.abnormal_mechanism = context.abnormal_mechanism;
    }
    if (context.ignoreDuration) {
        session.ignoreDuration = context.ignoreDuration;
    }
    if (context.sid) {
        session.sid = context.sid.length === 32 ? context.sid : uuid4();
    }
    if (context.init !== void 0) {
        session.init = context.init;
    }
    if (!session.did && context.did) {
        session.did = "".concat(context.did);
    }
    if (typeof context.started === "number") {
        session.started = context.started;
    }
    if (session.ignoreDuration) {
        session.duration = void 0;
    } else if (typeof context.duration === "number") {
        session.duration = context.duration;
    } else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) {
        session.release = context.release;
    }
    if (context.environment) {
        session.environment = context.environment;
    }
    if (!session.ipAddress && context.ipAddress) {
        session.ipAddress = context.ipAddress;
    }
    if (!session.userAgent && context.userAgent) {
        session.userAgent = context.userAgent;
    }
    if (typeof context.errors === "number") {
        session.errors = context.errors;
    }
    if (context.status) {
        session.status = context.status;
    }
}
function closeSession(session, status) {
    var context = {};
    if (status) {
        context = {
            status: status
        };
    } else if (session.status === "ok") {
        context = {
            status: "exited"
        };
    }
    updateSession(session, context);
}
function sessionToJSON(session) {
    return dropUndefinedKeys({
        sid: "".concat(session.sid),
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? "".concat(session.did) : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/utils/spanUtils.js
var TRACE_FLAG_SAMPLED = 1;
function spanToTraceContext(span) {
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    var _spanToJSON = spanToJSON(span), data = _spanToJSON.data, op = _spanToJSON.op, parent_span_id = _spanToJSON.parent_span_id, status = _spanToJSON.status, tags = _spanToJSON.tags, origin = _spanToJSON.origin;
    return dropUndefinedKeys({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
function spanToJSON(span) {
    if (spanIsSpanClass(span)) {
        return span.getSpanJSON();
    }
    if (typeof span.toJSON === "function") {
        return span.toJSON();
    }
    return {};
}
function spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
function spanIsSampled(span) {
    var traceFlags = span.spanContext().traceFlags;
    return Boolean(traceFlags & TRACE_FLAG_SAMPLED);
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/utils/prepareEvent.js
function parseEventHintOrCaptureContext(hint) {
    if (!hint) {
        return void 0;
    }
    if (hintIsScopeOrFunction(hint)) {
        return {
            captureContext: hint
        };
    }
    if (hintIsScopeContext(hint)) {
        return {
            captureContext: hint
        };
    }
    return hint;
}
function hintIsScopeOrFunction(hint) {
    return _instanceof(hint, Scope) || typeof hint === "function";
}
var captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function hintIsScopeContext(hint) {
    return Object.keys(hint).some(function(key) {
        return captureContextKeys.includes(key);
    });
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/exports.js
function captureException(exception, hint) {
    return getCurrentHub().captureException(exception, parseEventHintOrCaptureContext(hint));
}
function captureEvent(event, hint) {
    return getCurrentHub().captureEvent(event, hint);
}
function addBreadcrumb(breadcrumb, hint) {
    getCurrentHub().addBreadcrumb(breadcrumb, hint);
}
function withScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var hub = getCurrentHub();
    if (rest.length === 2) {
        var _rest = _sliced_to_array(rest, 2), scope = _rest[0], callback = _rest[1];
        if (!scope) {
            return hub.withScope(callback);
        }
        return hub.withScope(function() {
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    return hub.withScope(rest[0]);
}
function getClient() {
    return getCurrentHub().getClient();
}
function getCurrentScope() {
    return getCurrentHub().getScope();
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/utils/getRootSpan.js
function getRootSpan(span) {
    return span.transaction;
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
function getDynamicSamplingContextFromClient(trace_id, client, scope) {
    var options = client.getOptions();
    var _ref = client.getDsn() || {}, public_key = _ref.publicKey;
    var _ref1 = scope && scope.getUser() || {}, user_segment = _ref1.segment;
    var dsc = dropUndefinedKeys({
        environment: options.environment || DEFAULT_ENVIRONMENT,
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
function getDynamicSamplingContextFromSpan(span) {
    var client = getClient();
    if (!client) {
        return {};
    }
    var dsc = getDynamicSamplingContextFromClient(spanToJSON(span).trace_id || "", client, getCurrentScope());
    var txn = getRootSpan(span);
    if (!txn) {
        return dsc;
    }
    var v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) {
        return v7FrozenDsc;
    }
    var _txn_metadata = txn.metadata, maybeSampleRate = _txn_metadata.sampleRate, source = _txn_metadata.source;
    if (maybeSampleRate != null) {
        dsc.sample_rate = "".concat(maybeSampleRate);
    }
    var jsonSpan = spanToJSON(txn);
    if (source && source !== "url") {
        dsc.transaction = jsonSpan.description;
    }
    dsc.sampled = String(spanIsSampled(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/utils/applyScopeDataToEvent.js
function applyScopeDataToEvent(event, data) {
    var fingerprint = data.fingerprint, span = data.span, breadcrumbs = data.breadcrumbs, sdkProcessingMetadata = data.sdkProcessingMetadata;
    applyDataToEvent(event, data);
    if (span) {
        applySpanToEvent(event, span);
    }
    applyFingerprintToEvent(event, fingerprint);
    applyBreadcrumbsToEvent(event, breadcrumbs);
    applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function applyDataToEvent(event, data) {
    var extra = data.extra, tags = data.tags, user = data.user, contexts = data.contexts, level = data.level, // eslint-disable-next-line deprecation/deprecation
    transactionName = data.transactionName;
    var cleanedExtra = dropUndefinedKeys(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) {
        event.extra = _object_spread({}, cleanedExtra, event.extra);
    }
    var cleanedTags = dropUndefinedKeys(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) {
        event.tags = _object_spread({}, cleanedTags, event.tags);
    }
    var cleanedUser = dropUndefinedKeys(user);
    if (cleanedUser && Object.keys(cleanedUser).length) {
        event.user = _object_spread({}, cleanedUser, event.user);
    }
    var cleanedContexts = dropUndefinedKeys(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) {
        event.contexts = _object_spread({}, cleanedContexts, event.contexts);
    }
    if (level) {
        event.level = level;
    }
    if (transactionName) {
        event.transaction = transactionName;
    }
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
    var mergedBreadcrumbs = _to_consumable_array(event.breadcrumbs || []).concat(_to_consumable_array(breadcrumbs));
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = _object_spread({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function applySpanToEvent(event, span) {
    event.contexts = _object_spread({
        trace: spanToTraceContext(span)
    }, event.contexts);
    var rootSpan = getRootSpan(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = _object_spread({
            dynamicSamplingContext: getDynamicSamplingContextFromSpan(span)
        }, event.sdkProcessingMetadata);
        var transactionName = spanToJSON(rootSpan).description;
        if (transactionName) {
            event.tags = _object_spread({
                transaction: transactionName
            }, event.tags);
        }
    }
}
function applyFingerprintToEvent(event, fingerprint) {
    event.fingerprint = event.fingerprint ? arrayify(event.fingerprint) : [];
    if (fingerprint) {
        event.fingerprint = event.fingerprint.concat(fingerprint);
    }
    if (event.fingerprint && !event.fingerprint.length) {
        delete event.fingerprint;
    }
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/scope.js
var DEFAULT_MAX_BREADCRUMBS = 100;
var Scope = /*#__PURE__*/ function() {
    "use strict";
    function _Scope() {
        _class_call_check(this, _Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = generatePropagationContext();
    }
    _create_class(_Scope, [
        {
            /**
   * Clone this scope instance.
   */ key: "clone",
            value: function clone() {
                var newScope = new _Scope();
                newScope._breadcrumbs = _to_consumable_array(this._breadcrumbs);
                newScope._tags = _object_spread({}, this._tags);
                newScope._extra = _object_spread({}, this._extra);
                newScope._contexts = _object_spread({}, this._contexts);
                newScope._user = this._user;
                newScope._level = this._level;
                newScope._span = this._span;
                newScope._session = this._session;
                newScope._transactionName = this._transactionName;
                newScope._fingerprint = this._fingerprint;
                newScope._eventProcessors = _to_consumable_array(this._eventProcessors);
                newScope._requestSession = this._requestSession;
                newScope._attachments = _to_consumable_array(this._attachments);
                newScope._sdkProcessingMetadata = _object_spread({}, this._sdkProcessingMetadata);
                newScope._propagationContext = _object_spread({}, this._propagationContext);
                newScope._client = this._client;
                return newScope;
            }
        },
        {
            /** Update the client on the scope. */ key: "setClient",
            value: function setClient(client) {
                this._client = client;
            }
        },
        {
            /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ key: "getClient",
            value: function getClient() {
                return this._client;
            }
        },
        {
            /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setUser",
            value: function setUser(user) {
                this._user = user || {
                    email: void 0,
                    id: void 0,
                    ip_address: void 0,
                    segment: void 0,
                    username: void 0
                };
                if (this._session) {
                    updateSession(this._session, {
                        user: user
                    });
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getRequestSession",
            value: function getRequestSession() {
                return this._requestSession;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setRequestSession",
            value: function setRequestSession(requestSession) {
                this._requestSession = requestSession;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = _object_spread({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this._tags = _object_spread_props(_object_spread({}, this._tags), _define_property({}, key, value));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = _object_spread({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = _object_spread_props(_object_spread({}, this._extra), _define_property({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setLevel",
            value: function setLevel(level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the transaction name on the scope for future events.
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) {
                    delete this._contexts[key];
                } else {
                    this._contexts[key] = context;
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ key: "setSpan",
            value: function setSpan(span) {
                this._span = span;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ key: "getSpan",
            value: function getSpan() {
                return this._span;
            }
        },
        {
            /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ key: "getTransaction",
            value: function getTransaction() {
                var span = this._span;
                return span && span.transaction;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) {
                    delete this._session;
                } else {
                    this._session = session;
                }
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) {
                    return this;
                }
                var scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
                if (_instanceof(scopeToMerge, _Scope)) {
                    var scopeData = scopeToMerge.getScopeData();
                    this._tags = _object_spread({}, this._tags, scopeData.tags);
                    this._extra = _object_spread({}, this._extra, scopeData.extra);
                    this._contexts = _object_spread({}, this._contexts, scopeData.contexts);
                    if (scopeData.user && Object.keys(scopeData.user).length) {
                        this._user = scopeData.user;
                    }
                    if (scopeData.level) {
                        this._level = scopeData.level;
                    }
                    if (scopeData.fingerprint.length) {
                        this._fingerprint = scopeData.fingerprint;
                    }
                    if (scopeToMerge.getRequestSession()) {
                        this._requestSession = scopeToMerge.getRequestSession();
                    }
                    if (scopeData.propagationContext) {
                        this._propagationContext = scopeData.propagationContext;
                    }
                } else if (isPlainObject(scopeToMerge)) {
                    var scopeContext = captureContext;
                    this._tags = _object_spread({}, this._tags, scopeContext.tags);
                    this._extra = _object_spread({}, this._extra, scopeContext.extra);
                    this._contexts = _object_spread({}, this._contexts, scopeContext.contexts);
                    if (scopeContext.user) {
                        this._user = scopeContext.user;
                    }
                    if (scopeContext.level) {
                        this._level = scopeContext.level;
                    }
                    if (scopeContext.fingerprint) {
                        this._fingerprint = scopeContext.fingerprint;
                    }
                    if (scopeContext.requestSession) {
                        this._requestSession = scopeContext.requestSession;
                    }
                    if (scopeContext.propagationContext) {
                        this._propagationContext = scopeContext.propagationContext;
                    }
                }
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clear",
            value: function clear() {
                this._breadcrumbs = [];
                this._tags = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = void 0;
                this._transactionName = void 0;
                this._fingerprint = void 0;
                this._requestSession = void 0;
                this._span = void 0;
                this._session = void 0;
                this._notifyScopeListeners();
                this._attachments = [];
                this._propagationContext = generatePropagationContext();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
                if (maxCrumbs <= 0) {
                    return this;
                }
                var mergedBreadcrumb = _object_spread({
                    timestamp: dateTimestampInSeconds()
                }, breadcrumb);
                var breadcrumbs = this._breadcrumbs;
                breadcrumbs.push(mergedBreadcrumb);
                this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ key: "getAttachments",
            value: function getAttachments() {
                var data = this.getScopeData();
                return data.attachments;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "getScopeData",
            value: function getScopeData() {
                var _this = this, _breadcrumbs = _this._breadcrumbs, _attachments = _this._attachments, _contexts = _this._contexts, _tags = _this._tags, _extra = _this._extra, _user = _this._user, _level = _this._level, _fingerprint = _this._fingerprint, _eventProcessors = _this._eventProcessors, _propagationContext = _this._propagationContext, _sdkProcessingMetadata = _this._sdkProcessingMetadata, _transactionName = _this._transactionName, _span = _this._span;
                return {
                    breadcrumbs: _breadcrumbs,
                    attachments: _attachments,
                    contexts: _contexts,
                    tags: _tags,
                    extra: _extra,
                    user: _user,
                    level: _level,
                    fingerprint: _fingerprint || [],
                    eventProcessors: _eventProcessors,
                    propagationContext: _propagationContext,
                    sdkProcessingMetadata: _sdkProcessingMetadata,
                    transactionName: _transactionName,
                    span: _span
                };
            }
        },
        {
            /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ key: "applyToEvent",
            value: function applyToEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, additionalEventProcessors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                applyScopeDataToEvent(event, this.getScopeData());
                var eventProcessors = _to_consumable_array(additionalEventProcessors).concat(// eslint-disable-next-line deprecation/deprecation
                _to_consumable_array(getGlobalEventProcessors()), _to_consumable_array(this._eventProcessors));
                return notifyEventProcessors(eventProcessors, event, hint);
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = _object_spread({}, this._sdkProcessingMetadata, newData);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : uuid4();
                if (!this._client) {
                    logger.warn("No client configured on scope - will not capture exception!");
                    return eventId;
                }
                var syntheticException = new Error("Sentry syntheticException");
                this._client.captureException(exception, _object_spread_props(_object_spread({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : uuid4();
                if (!this._client) {
                    logger.warn("No client configured on scope - will not capture message!");
                    return eventId;
                }
                var syntheticException = new Error(message);
                this._client.captureMessage(message, level, _object_spread_props(_object_spread({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : uuid4();
                if (!this._client) {
                    logger.warn("No client configured on scope - will not capture event!");
                    return eventId;
                }
                this._client.captureEvent(event, _object_spread_props(_object_spread({}, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        }
    ], [
        {
            key: "clone",
            value: /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ function clone(scope) {
                return scope ? scope.clone() : new _Scope();
            }
        }
    ]);
    return _Scope;
}();
function generatePropagationContext() {
    return {
        traceId: uuid4(),
        spanId: uuid4().substring(16)
    };
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/version.js
var SDK_VERSION = "7.120.4";
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/hub.js
var API_VERSION = parseFloat(SDK_VERSION);
var DEFAULT_BREADCRUMBS = 100;
var Hub = /*#__PURE__*/ function() {
    "use strict";
    function Hub(client, scope, isolationScope) {
        var _version = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : API_VERSION;
        _class_call_check(this, Hub);
        this._version = _version;
        var assignedScope;
        if (!scope) {
            assignedScope = new Scope();
            assignedScope.setClient(client);
        } else {
            assignedScope = scope;
        }
        var assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new Scope();
            assignedIsolationScope.setClient(client);
        } else {
            assignedIsolationScope = isolationScope;
        }
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) {
            this.bindClient(client);
        }
        this._isolationScope = assignedIsolationScope;
    }
    _create_class(Hub, [
        {
            /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ key: "isOlderThan",
            value: function isOlderThan(version) {
                return this._version < version;
            }
        },
        {
            /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ key: "bindClient",
            value: function bindClient(client) {
                var top = this.getStackTop();
                top.client = client;
                top.scope.setClient(client);
                if (client && client.setupIntegrations) {
                    client.setupIntegrations();
                }
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "pushScope",
            value: function pushScope() {
                var scope = this.getScope().clone();
                this.getStack().push({
                    // eslint-disable-next-line deprecation/deprecation
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "popScope",
            value: function popScope() {
                if (this.getStack().length <= 1) return false;
                return !!this.getStack().pop();
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ key: "withScope",
            value: function withScope(callback) {
                var _this = this;
                var scope = this.pushScope();
                var maybePromiseResult;
                try {
                    maybePromiseResult = callback(scope);
                } catch (e) {
                    this.popScope();
                    throw e;
                }
                if (isThenable(maybePromiseResult)) {
                    return maybePromiseResult.then(function(res) {
                        _this.popScope();
                        return res;
                    }, function(e) {
                        _this.popScope();
                        throw e;
                    });
                }
                this.popScope();
                return maybePromiseResult;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ key: "getClient",
            value: function getClient() {
                return this.getStackTop().client;
            }
        },
        {
            /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ key: "getScope",
            value: function getScope() {
                return this.getStackTop().scope;
            }
        },
        {
            /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ key: "getIsolationScope",
            value: function getIsolationScope() {
                return this._isolationScope;
            }
        },
        {
            /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ key: "getStack",
            value: function getStack() {
                return this._stack;
            }
        },
        {
            /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4();
                var syntheticException = new Error("Sentry syntheticException");
                this.getScope().captureException(exception, _object_spread_props(_object_spread({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4();
                var syntheticException = new Error(message);
                this.getScope().captureMessage(message, level, _object_spread_props(_object_spread({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : uuid4();
                if (!event.type) {
                    this._lastEventId = eventId;
                }
                this.getScope().captureEvent(event, _object_spread_props(_object_spread({}, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, hint) {
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                if (!client) return;
                var _ref = client.getOptions && client.getOptions() || {}, _ref_beforeBreadcrumb = _ref.beforeBreadcrumb, beforeBreadcrumb = _ref_beforeBreadcrumb === void 0 ? null : _ref_beforeBreadcrumb, _ref_maxBreadcrumbs = _ref.maxBreadcrumbs, maxBreadcrumbs = _ref_maxBreadcrumbs === void 0 ? DEFAULT_BREADCRUMBS : _ref_maxBreadcrumbs;
                if (maxBreadcrumbs <= 0) return;
                var timestamp = dateTimestampInSeconds();
                var mergedBreadcrumb = _object_spread({
                    timestamp: timestamp
                }, breadcrumb);
                var finalBreadcrumb = beforeBreadcrumb ? consoleSandbox(function() {
                    return beforeBreadcrumb(mergedBreadcrumb, hint);
                }) : mergedBreadcrumb;
                if (finalBreadcrumb === null) return;
                if (client.emit) {
                    client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
                }
                scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ key: "setUser",
            value: function setUser(user) {
                this.getScope().setUser(user);
                this.getIsolationScope().setUser(user);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ key: "setTags",
            value: function setTags(tags) {
                this.getScope().setTags(tags);
                this.getIsolationScope().setTags(tags);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ key: "setExtras",
            value: function setExtras(extras) {
                this.getScope().setExtras(extras);
                this.getIsolationScope().setExtras(extras);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ key: "setTag",
            value: function setTag(key, value) {
                this.getScope().setTag(key, value);
                this.getIsolationScope().setTag(key, value);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this.getScope().setExtra(key, extra);
                this.getIsolationScope().setExtra(key, extra);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setContext",
            value: function setContext(name, context) {
                this.getScope().setContext(name, context);
                this.getIsolationScope().setContext(name, context);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ key: "configureScope",
            value: function configureScope(callback) {
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                if (client) {
                    callback(scope);
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "run",
            value: function run(callback) {
                var oldHub = makeMain(this);
                try {
                    callback(this);
                } finally{
                    makeMain(oldHub);
                }
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                var client = this.getClient();
                if (!client) return null;
                try {
                    return client.getIntegration(integration);
                } catch (_oO) {
                    DEBUG_BUILD2 && logger.warn("Cannot retrieve integration ".concat(integration.id, " from the current Hub"));
                    return null;
                }
            }
        },
        {
            /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ key: "startTransaction",
            value: function startTransaction(context, customSamplingContext) {
                var result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
                if (DEBUG_BUILD2 && !result) {
                    var client = this.getClient();
                    if (!client) {
                        logger.warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
                    } else {
                        logger.warn("Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':\nSentry.addTracingExtensions();\nSentry.init({...});\n");
                    }
                }
                return result;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ key: "traceHeaders",
            value: function traceHeaders() {
                return this._callExtensionMethod("traceHeaders");
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ key: "captureSession",
            value: function captureSession() {
                var endSession2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (endSession2) {
                    return this.endSession();
                }
                this._sendSessionUpdate();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ key: "endSession",
            value: function endSession() {
                var layer = this.getStackTop();
                var scope = layer.scope;
                var session = scope.getSession();
                if (session) {
                    closeSession(session);
                }
                this._sendSessionUpdate();
                scope.setSession();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ key: "startSession",
            value: function startSession(context) {
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                var _ref = client && client.getOptions() || {}, release = _ref.release, _ref_environment = _ref.environment, environment = _ref_environment === void 0 ? DEFAULT_ENVIRONMENT : _ref_environment;
                var userAgent = (GLOBAL_OBJ.navigator || {}).userAgent;
                var session = makeSession(_object_spread({
                    release: release,
                    environment: environment,
                    user: scope.getUser()
                }, userAgent && {
                    userAgent: userAgent
                }, context));
                var currentSession = scope.getSession && scope.getSession();
                if (currentSession && currentSession.status === "ok") {
                    updateSession(currentSession, {
                        status: "exited"
                    });
                }
                this.endSession();
                scope.setSession(session);
                return session;
            }
        },
        {
            /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ key: "shouldSendDefaultPii",
            value: function shouldSendDefaultPii() {
                var client = this.getClient();
                var options = client && client.getOptions();
                return Boolean(options && options.sendDefaultPii);
            }
        },
        {
            /**
   * Sends the current Session on the scope
   */ key: "_sendSessionUpdate",
            value: function _sendSessionUpdate() {
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                var session = scope.getSession();
                if (session && client && client.captureSession) {
                    client.captureSession(session);
                }
            }
        },
        {
            /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "_callExtensionMethod",
            value: function _callExtensionMethod(method) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var carrier = getMainCarrier();
                var sentry = carrier.__SENTRY__;
                if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") {
                    return sentry.extensions[method].apply(this, args);
                }
                DEBUG_BUILD2 && logger.warn("Extension method ".concat(method, " couldn't be found, doing nothing."));
            }
        }
    ]);
    return Hub;
}();
function getMainCarrier() {
    GLOBAL_OBJ.__SENTRY__ = GLOBAL_OBJ.__SENTRY__ || {
        extensions: {},
        hub: void 0
    };
    return GLOBAL_OBJ;
}
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
function getCurrentHub() {
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        var hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) {
            return hub;
        }
    }
    return getGlobalHub(registry);
}
function getGlobalHub() {
    var registry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getMainCarrier();
    if (!hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    return getHubFromCarrier(registry);
}
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function getHubFromCarrier(carrier) {
    return getGlobalSingleton("hub", function() {
        return new Hub();
    }, carrier);
}
function setHubOnCarrier(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/integration.js
function convertIntegrationFnToClass(name, fn) {
    var ConvertedIntegration = function ConvertedIntegration2() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return fn.apply(void 0, _to_consumable_array(args));
    };
    ConvertedIntegration.id = name;
    return ConvertedIntegration;
}
function defineIntegration(fn) {
    return fn;
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/integrations/inboundfilters.js
var DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
var DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
var INTEGRATION_NAME = "InboundFilters";
var _inboundFiltersIntegration = function _inboundFiltersIntegration() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        processEvent: function processEvent(event, _hint, client) {
            var clientOptions = client.getOptions();
            var mergedOptions = _mergeOptions(options, clientOptions);
            return _shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
var inboundFiltersIntegration = defineIntegration(_inboundFiltersIntegration);
var InboundFilters = convertIntegrationFnToClass(INTEGRATION_NAME, inboundFiltersIntegration);
function _mergeOptions() {
    var internalOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, clientOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        allowUrls: _to_consumable_array(internalOptions.allowUrls || []).concat(_to_consumable_array(clientOptions.allowUrls || [])),
        denyUrls: _to_consumable_array(internalOptions.denyUrls || []).concat(_to_consumable_array(clientOptions.denyUrls || [])),
        ignoreErrors: _to_consumable_array(internalOptions.ignoreErrors || []).concat(_to_consumable_array(clientOptions.ignoreErrors || []), _to_consumable_array(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS)),
        ignoreTransactions: _to_consumable_array(internalOptions.ignoreTransactions || []).concat(_to_consumable_array(clientOptions.ignoreTransactions || []), _to_consumable_array(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS)),
        ignoreInternal: internalOptions.ignoreInternal !== void 0 ? internalOptions.ignoreInternal : true
    };
}
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        DEBUG_BUILD2 && logger.warn("Event dropped due to being internal Sentry Error.\nEvent: ".concat(getEventDescription(event)));
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        DEBUG_BUILD2 && logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat(getEventDescription(event)));
        return true;
    }
    if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
        DEBUG_BUILD2 && logger.warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat(getEventDescription(event)));
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        DEBUG_BUILD2 && logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat(getEventDescription(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        DEBUG_BUILD2 && logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat(getEventDescription(event), ".\nUrl: ").concat(_getEventFilterUrl(event)));
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    if (event.type || !ignoreErrors || !ignoreErrors.length) {
        return false;
    }
    return _getPossibleEventMessages(event).some(function(message) {
        return stringMatchesSomePattern(message, ignoreErrors);
    });
}
function _isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) {
        return false;
    }
    var name = event.transaction;
    return name ? stringMatchesSomePattern(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
    if (!denyUrls || !denyUrls.length) {
        return false;
    }
    var url = _getEventFilterUrl(event);
    return !url ? false : stringMatchesSomePattern(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
    if (!allowUrls || !allowUrls.length) {
        return true;
    }
    var url = _getEventFilterUrl(event);
    return !url ? true : stringMatchesSomePattern(url, allowUrls);
}
function _getPossibleEventMessages(event) {
    var possibleMessages = [];
    if (event.message) {
        possibleMessages.push(event.message);
    }
    var lastException;
    try {
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {}
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) {
                possibleMessages.push("".concat(lastException.type, ": ").concat(lastException.value));
            }
        }
    }
    if (DEBUG_BUILD2 && possibleMessages.length === 0) {
        logger.error("Could not extract message for event ".concat(getEventDescription(event)));
    }
    return possibleMessages;
}
function _isSentryError(event) {
    try {
        return event.exception.values[0].type === "SentryError";
    } catch (e) {}
    return false;
}
function _getLastValidUrl() {
    var frames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") {
            return frame.filename || null;
        }
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        var frames;
        try {
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {}
        return frames ? _getLastValidUrl(frames) : null;
    } catch (oO) {
        DEBUG_BUILD2 && logger.error("Cannot extract url for event ".concat(getEventDescription(event)));
        return null;
    }
}
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/integrations/functiontostring.js
var originalFunctionToString;
var INTEGRATION_NAME2 = "FunctionToString";
var SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
var _functionToStringIntegration = function _functionToStringIntegration() {
    return {
        name: INTEGRATION_NAME2,
        setupOnce: function setupOnce() {
            originalFunctionToString = Function.prototype.toString;
            try {
                Function.prototype.toString = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var originalFunction = getOriginalFunction(this);
                    var context = SETUP_CLIENTS.has(getClient()) && originalFunction !== void 0 ? originalFunction : this;
                    return originalFunctionToString.apply(context, args);
                };
            } catch (e) {}
        },
        setup: function setup(client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
var functionToStringIntegration = defineIntegration(_functionToStringIntegration);
var FunctionToString = convertIntegrationFnToClass(INTEGRATION_NAME2, functionToStringIntegration);
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/integrations/linkederrors.js
var DEFAULT_KEY = "cause";
var DEFAULT_LIMIT = 5;
var INTEGRATION_NAME3 = "LinkedErrors";
var _linkedErrorsIntegration = function _linkedErrorsIntegration() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || DEFAULT_LIMIT;
    var key = options.key || DEFAULT_KEY;
    return {
        name: INTEGRATION_NAME3,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        preprocessEvent: function preprocessEvent(event, hint, client) {
            var options2 = client.getOptions();
            applyAggregateErrorsToEvent(exceptionFromError, options2.stackParser, options2.maxValueLength, key, limit, event, hint);
        }
    };
};
var linkedErrorsIntegration = defineIntegration(_linkedErrorsIntegration);
var LinkedErrors = convertIntegrationFnToClass(INTEGRATION_NAME3, linkedErrorsIntegration);
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/integrations/index.js
var integrations_exports = {};
__export(integrations_exports, {
    FunctionToString: function FunctionToString1() {
        return FunctionToString;
    },
    InboundFilters: function InboundFilters1() {
        return InboundFilters;
    },
    LinkedErrors: function LinkedErrors1() {
        return LinkedErrors;
    }
});
// ../../node_modules/@sentry/browser/node_modules/@sentry/core/esm/index.js
var Integrations = integrations_exports;
// ../../node_modules/@sentry/browser/esm/helpers.js
var WINDOW7 = GLOBAL_OBJ;
var ignoreOnError = 0;
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
function ignoreNextOnError() {
    ignoreOnError++;
    setTimeout(function() {
        ignoreOnError--;
    });
}
function wrap(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, before = arguments.length > 2 ? arguments[2] : void 0;
    if (typeof fn !== "function") {
        return fn;
    }
    try {
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") {
                return wrapper;
            } else {
                return fn;
            }
        }
        if (getOriginalFunction(fn)) {
            return fn;
        }
    } catch (e) {
        return fn;
    }
    var sentryWrapped = function sentryWrapped() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") {
                before.apply(this, arguments);
            }
            var wrappedArguments = args.map(function(arg) {
                return wrap(arg, options);
            });
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            ignoreNextOnError();
            withScope(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        addExceptionTypeValue(event, void 0, void 0);
                        addExceptionMechanism(event, options.mechanism);
                    }
                    event.extra = _object_spread_props(_object_spread({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                captureException(ex);
            });
            throw ex;
        }
    };
    try {
        for(var property in fn){
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    } catch (_oO) {}
    markFunctionWrapped(sentryWrapped, fn);
    addNonEnumerableProperty(fn, "__sentry_wrapped__", sentryWrapped);
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, "name", {
                get: function get() {
                    return fn.name;
                }
            });
        }
    } catch (_oO) {}
    return sentryWrapped;
}
// ../../node_modules/@sentry/browser/esm/debug-build.js
var DEBUG_BUILD3 = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
// ../../node_modules/@sentry/browser/esm/eventbuilder.js
function exceptionFromError2(stackParser, ex) {
    var frames = parseStackFrames2(stackParser, ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex)
    };
    if (frames.length) {
        exception.stacktrace = {
            frames: frames
        };
    }
    if (exception.type === void 0 && exception.value === "") {
        exception.value = "Unrecoverable error caught";
    }
    return exception;
}
function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    var client = getClient();
    var normalizeDepth = client && client.getOptions().normalizeDepth;
    var event = {
        exception: {
            values: [
                {
                    type: isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: normalizeToSize(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        var frames = parseStackFrames2(stackParser, syntheticException);
        if (frames.length) {
            event.exception.values[0].stacktrace = {
                frames: frames
            };
        }
    }
    return event;
}
function eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                exceptionFromError2(stackParser, ex)
            ]
        }
    };
}
function parseStackFrames2(stackParser, ex) {
    var stacktrace = ex.stacktrace || ex.stack || "";
    var popSize = getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {}
    return [];
}
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return "No error message";
    }
    if (message.error && typeof message.error.message === "string") {
        return message.error.message;
    }
    return message;
}
function eventFromUnknownInput2(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if (isErrorEvent(exception) && exception.error) {
        var errorEvent = exception;
        return eventFromError(stackParser, errorEvent.error);
    }
    if (isDOMError(exception) || isDOMException(exception)) {
        var domException = exception;
        if ("stack" in exception) {
            event = eventFromError(stackParser, exception);
        } else {
            var name = domException.name || (isDOMError(domException) ? "DOMError" : "DOMException");
            var message = domException.message ? "".concat(name, ": ").concat(domException.message) : name;
            event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
            addExceptionTypeValue(event, message);
        }
        if ("code" in domException) {
            event.tags = _object_spread_props(_object_spread({}, event.tags), {
                "DOMException.code": "".concat(domException.code)
            });
        }
        return event;
    }
    if (isError(exception)) {
        return eventFromError(stackParser, exception);
    }
    if (isPlainObject(exception) || isEvent(exception)) {
        var objectException = exception;
        event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        addExceptionMechanism(event, {
            synthetic: true
        });
        return event;
    }
    event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    addExceptionTypeValue(event, "".concat(exception), void 0);
    addExceptionMechanism(event, {
        synthetic: true
    });
    return event;
}
function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    var event = {};
    if (attachStacktrace && syntheticException) {
        var frames = parseStackFrames2(stackParser, syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
        }
    }
    if (isParameterizedString(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function getNonErrorObjectExceptionValue(exception, param) {
    var isUnhandledRejection = param.isUnhandledRejection;
    var keys = extractExceptionKeysForMessage(exception);
    var captureType = isUnhandledRejection ? "promise rejection" : "exception";
    if (isErrorEvent(exception)) {
        return "Event `ErrorEvent` captured as ".concat(captureType, " with message `").concat(exception.message, "`");
    }
    if (isEvent(exception)) {
        var className = getObjectClassName(exception);
        return "Event `".concat(className, "` (type=").concat(exception.type, ") captured as ").concat(captureType);
    }
    return "Object captured as ".concat(captureType, " with keys: ").concat(keys);
}
function getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : void 0;
    } catch (e) {}
}
// ../../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js
var MAX_ALLOWED_STRING_LENGTH = 1024;
var INTEGRATION_NAME4 = "Breadcrumbs";
var _breadcrumbsIntegration = function _breadcrumbsIntegration() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = _object_spread({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: INTEGRATION_NAME4,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        setup: function setup(client) {
            if (_options.console) {
                addConsoleInstrumentationHandler(_getConsoleBreadcrumbHandler(client));
            }
            if (_options.dom) {
                addClickKeypressInstrumentationHandler(_getDomBreadcrumbHandler(client, _options.dom));
            }
            if (_options.xhr) {
                addXhrInstrumentationHandler(_getXhrBreadcrumbHandler(client));
            }
            if (_options.fetch) {
                addFetchInstrumentationHandler(_getFetchBreadcrumbHandler(client));
            }
            if (_options.history) {
                addHistoryInstrumentationHandler(_getHistoryBreadcrumbHandler(client));
            }
            if (_options.sentry && client.on) {
                client.on("beforeSendEvent", _getSentryBreadcrumbHandler(client));
            }
        }
    };
};
var breadcrumbsIntegration = defineIntegration(_breadcrumbsIntegration);
var Breadcrumbs = convertIntegrationFnToClass(INTEGRATION_NAME4, breadcrumbsIntegration);
function _getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if (getClient() !== client) {
            return;
        }
        addBreadcrumb({
            category: "sentry.".concat(event.type === "transaction" ? "transaction" : "event"),
            event_id: event.event_id,
            level: event.level,
            message: getEventDescription(event)
        }, {
            event: event
        });
    };
}
function _getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if (getClient() !== client) {
            return;
        }
        var target;
        var componentName;
        var keyAttrs = (typeof dom === "undefined" ? "undefined" : _type_of(dom)) === "object" ? dom.serializeAttribute : void 0;
        var maxStringLength = (typeof dom === "undefined" ? "undefined" : _type_of(dom)) === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
        if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
            DEBUG_BUILD3 && logger.warn("`dom.maxStringLength` cannot exceed ".concat(MAX_ALLOWED_STRING_LENGTH, ", but a value of ").concat(maxStringLength, " was configured. Sentry will use ").concat(MAX_ALLOWED_STRING_LENGTH, " instead."));
            maxStringLength = MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") {
            keyAttrs = [
                keyAttrs
            ];
        }
        try {
            var event = handlerData.event;
            var element = _isEvent(event) ? event.target : event;
            target = htmlTreeAsString(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = getComponentName(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) {
            return;
        }
        var breadcrumb = {
            category: "ui.".concat(handlerData.name),
            message: target
        };
        if (componentName) {
            breadcrumb.data = {
                "ui.component_name": componentName
            };
        }
        addBreadcrumb(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
function _getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if (getClient() !== client) {
            return;
        }
        var breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: severityLevelFromString(handlerData.level),
            message: safeJoin(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: ".concat(safeJoin(handlerData.args.slice(1), " ") || "console.assert");
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else {
                return;
            }
        }
        addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
function _getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if (getClient() !== client) {
            return;
        }
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        var sentryXhrData = handlerData.xhr[SENTRY_XHR_DATA_KEY];
        if (!startTimestamp || !endTimestamp || !sentryXhrData) {
            return;
        }
        var method = sentryXhrData.method, url = sentryXhrData.url, status_code = sentryXhrData.status_code, body = sentryXhrData.body;
        var data = {
            method: method,
            url: url,
            status_code: status_code
        };
        var hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        addBreadcrumb({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
function _getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if (getClient() !== client) {
            return;
        }
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        if (!endTimestamp) {
            return;
        }
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") {
            return;
        }
        if (handlerData.error) {
            var data = handlerData.fetchData;
            var hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            addBreadcrumb({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            var response = handlerData.response;
            var data1 = _object_spread_props(_object_spread({}, handlerData.fetchData), {
                status_code: response && response.status
            });
            var hint1 = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            addBreadcrumb({
                category: "fetch",
                data: data1,
                type: "http"
            }, hint1);
        }
    };
}
function _getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if (getClient() !== client) {
            return;
        }
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = parseUrl2(WINDOW7.location.href);
        var parsedFrom = from ? parseUrl2(from) : void 0;
        var parsedTo = parseUrl2(to);
        if (!parsedFrom || !parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            from = parsedFrom.relative;
        }
        addBreadcrumb({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function _isEvent(event) {
    return !!event && !!event.target;
}
// ../../node_modules/@sentry/browser/esm/integrations/dedupe.js
var INTEGRATION_NAME5 = "Dedupe";
var _dedupeIntegration = function _dedupeIntegration() {
    var previousEvent;
    return {
        name: INTEGRATION_NAME5,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        processEvent: function processEvent(currentEvent) {
            if (currentEvent.type) {
                return currentEvent;
            }
            try {
                if (_shouldDropEvent2(currentEvent, previousEvent)) {
                    DEBUG_BUILD3 && logger.warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {}
            return previousEvent = currentEvent;
        }
    };
};
var dedupeIntegration = defineIntegration(_dedupeIntegration);
var Dedupe = convertIntegrationFnToClass(INTEGRATION_NAME5, dedupeIntegration);
function _shouldDropEvent2(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    if (!currentMessage && !previousMessage) {
        return false;
    }
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    if (!currentFrames && !previousFrames) {
        return true;
    }
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            return exception.values[0].stacktrace.frames;
        } catch (_oO) {
            return void 0;
        }
    }
    return void 0;
}
// ../../node_modules/@sentry/browser/esm/integrations/globalhandlers.js
var INTEGRATION_NAME6 = "GlobalHandlers";
var _globalHandlersIntegration = function _globalHandlersIntegration() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = _object_spread({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: INTEGRATION_NAME6,
        setupOnce: function setupOnce() {
            Error.stackTraceLimit = 50;
        },
        setup: function setup(client) {
            if (_options.onerror) {
                _installGlobalOnErrorHandler(client);
                globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                _installGlobalOnUnhandledRejectionHandler(client);
                globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
var globalHandlersIntegration = defineIntegration(_globalHandlersIntegration);
var GlobalHandlers = convertIntegrationFnToClass(INTEGRATION_NAME6, globalHandlersIntegration);
function _installGlobalOnErrorHandler(client) {
    addGlobalErrorInstrumentationHandler(function(data) {
        var _getOptions = getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if (getClient() !== client || shouldIgnoreOnError()) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        var event = error === void 0 && isString(msg) ? _eventFromIncompleteOnError(msg, url, line, column) : _enhanceEventWithInitialFrame(eventFromUnknownInput2(stackParser, error || msg, void 0, attachStacktrace, false), url, line, column);
        event.level = "error";
        captureEvent(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function _installGlobalOnUnhandledRejectionHandler(client) {
    addGlobalUnhandledRejectionInstrumentationHandler(function(e) {
        var _getOptions = getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if (getClient() !== client || shouldIgnoreOnError()) {
            return;
        }
        var error = _getUnhandledRejectionError(e);
        var event = isPrimitive(error) ? _eventFromRejectionWithPrimitive(error) : eventFromUnknownInput2(stackParser, error, void 0, attachStacktrace, true);
        event.level = "error";
        captureEvent(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function _getUnhandledRejectionError(error) {
    if (isPrimitive(error)) {
        return error;
    }
    var e = error;
    try {
        if ("reason" in e) {
            return e.reason;
        } else if ("detail" in e && "reason" in e.detail) {
            return e.detail.reason;
        }
    } catch (e2) {}
    return error;
}
function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: ".concat(String(reason))
                }
            ]
        }
    };
}
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    var message = isErrorEvent(msg) ? msg.message : msg;
    var name = "Error";
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
function _enhanceEventWithInitialFrame(event, url, line, column) {
    var e = event.exception = event.exception || {};
    var ev = e.values = e.values || [];
    var ev0 = ev[0] = ev[0] || {};
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? void 0 : column;
    var lineno = isNaN(parseInt(line, 10)) ? void 0 : line;
    var filename = isString(url) && url.length > 0 ? url : getLocationHref();
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: "?",
            in_app: true,
            lineno: lineno
        });
    }
    return event;
}
function globalHandlerLog(type) {
    DEBUG_BUILD3 && logger.log("Global Handler attached: ".concat(type));
}
function getOptions() {
    var client = getClient();
    var options = client && client.getOptions() || {
        stackParser: function stackParser() {
            return [];
        },
        attachStacktrace: false
    };
    return options;
}
// ../../node_modules/@sentry/browser/esm/integrations/httpcontext.js
var INTEGRATION_NAME7 = "HttpContext";
var _httpContextIntegration = function _httpContextIntegration() {
    return {
        name: INTEGRATION_NAME7,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        preprocessEvent: function preprocessEvent(event) {
            if (!WINDOW7.navigator && !WINDOW7.location && !WINDOW7.document) {
                return;
            }
            var url = event.request && event.request.url || WINDOW7.location && WINDOW7.location.href;
            var referrer = (WINDOW7.document || {}).referrer;
            var userAgent = (WINDOW7.navigator || {}).userAgent;
            var headers = _object_spread({}, event.request && event.request.headers, referrer && {
                Referer: referrer
            }, userAgent && {
                "User-Agent": userAgent
            });
            var request = _object_spread_props(_object_spread({}, event.request, url && {
                url: url
            }), {
                headers: headers
            });
            event.request = request;
        }
    };
};
var httpContextIntegration = defineIntegration(_httpContextIntegration);
var HttpContext = convertIntegrationFnToClass(INTEGRATION_NAME7, httpContextIntegration);
// ../../node_modules/@sentry/browser/esm/integrations/linkederrors.js
var DEFAULT_KEY2 = "cause";
var DEFAULT_LIMIT2 = 5;
var INTEGRATION_NAME8 = "LinkedErrors";
var _linkedErrorsIntegration2 = function _linkedErrorsIntegration2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || DEFAULT_LIMIT2;
    var key = options.key || DEFAULT_KEY2;
    return {
        name: INTEGRATION_NAME8,
        // TODO v8: Remove this
        setupOnce: function setupOnce() {},
        // eslint-disable-line @typescript-eslint/no-empty-function
        preprocessEvent: function preprocessEvent(event, hint, client) {
            var options2 = client.getOptions();
            applyAggregateErrorsToEvent(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            exceptionFromError2, options2.stackParser, options2.maxValueLength, key, limit, event, hint);
        }
    };
};
var linkedErrorsIntegration2 = defineIntegration(_linkedErrorsIntegration2);
var LinkedErrors2 = convertIntegrationFnToClass(INTEGRATION_NAME8, linkedErrorsIntegration2);
// ../../node_modules/@sentry/browser/esm/integrations/trycatch.js
var DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
var INTEGRATION_NAME9 = "TryCatch";
var _browserApiErrorsIntegration = function _browserApiErrorsIntegration() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = _object_spread({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true
    }, options);
    return {
        name: INTEGRATION_NAME9,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce: function setupOnce() {
            if (_options.setTimeout) {
                fill(WINDOW7, "setTimeout", _wrapTimeFunction);
            }
            if (_options.setInterval) {
                fill(WINDOW7, "setInterval", _wrapTimeFunction);
            }
            if (_options.requestAnimationFrame) {
                fill(WINDOW7, "requestAnimationFrame", _wrapRAF);
            }
            if (_options.XMLHttpRequest && "XMLHttpRequest" in WINDOW7) {
                fill(XMLHttpRequest.prototype, "send", _wrapXHR);
            }
            var eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
                eventTarget.forEach(_wrapEventTarget);
            }
        }
    };
};
var browserApiErrorsIntegration = defineIntegration(_browserApiErrorsIntegration);
var TryCatch = convertIntegrationFnToClass(INTEGRATION_NAME9, browserApiErrorsIntegration);
function _wrapTimeFunction(original) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var originalCallback = args[0];
        args[0] = wrap(originalCallback, {
            mechanism: {
                data: {
                    function: getFunctionName(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
function _wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            wrap(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: getFunctionName(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function _wrapXHR(originalSend) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var xhr = this;
        var xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === "function") {
                fill(xhr, prop, function(original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: getFunctionName(original)
                            },
                            handled: false,
                            type: "instrument"
                        }
                    };
                    var originalFunction = getOriginalFunction(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
                    }
                    return wrap(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
function _wrapEventTarget(target) {
    var globalObject = WINDOW7;
    var proto = globalObject[target] && globalObject[target].prototype;
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) {
        return;
    }
    fill(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") {
                    fn.handleEvent = wrap(fn.handleEvent, {
                        mechanism: {
                            data: {
                                function: "handleEvent",
                                handler: getFunctionName(fn),
                                target: target
                            },
                            handled: false,
                            type: "instrument"
                        }
                    });
                }
            } catch (err) {}
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                wrap(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: getFunctionName(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    fill(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            } catch (e) {}
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
// ../../node_modules/@sentry/browser/esm/integrations/index.js
var integrations_exports2 = {};
__export(integrations_exports2, {
    Breadcrumbs: function Breadcrumbs1() {
        return Breadcrumbs;
    },
    Dedupe: function Dedupe1() {
        return Dedupe;
    },
    GlobalHandlers: function GlobalHandlers1() {
        return GlobalHandlers;
    },
    HttpContext: function HttpContext1() {
        return HttpContext;
    },
    LinkedErrors: function LinkedErrors() {
        return LinkedErrors2;
    },
    TryCatch: function TryCatch1() {
        return TryCatch;
    }
});
// ../../node_modules/@sentry/browser/esm/index.js
var windowIntegrations = {};
if (WINDOW7.Sentry && WINDOW7.Sentry.Integrations) {
    windowIntegrations = WINDOW7.Sentry.Integrations;
}
var INTEGRATIONS = _object_spread({}, windowIntegrations, Integrations, integrations_exports2);
// src/tracking/matomo.ts
var MatomoProvider = /*#__PURE__*/ function() {
    "use strict";
    function MatomoProvider() {
        _class_call_check(this, MatomoProvider);
        if (typeof window !== "undefined") {
            window._paq = window._paq || [];
        } else {
            captureException(new Error("window is not defined"));
        }
    }
    _create_class(MatomoProvider, [
        {
            key: "sendEvent",
            value: function sendEvent(eventName, args) {
                var dryRun = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                pushToMatomo(eventName, args, dryRun);
            }
        },
        {
            key: "pageView",
            value: function pageView(documentTitle, href, _params) {
                var dryRun = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                pushToMatomo("setCustomUrl", [
                    href
                ], dryRun);
                pushToMatomo("setDocumentTitle", [
                    documentTitle
                ], dryRun);
            }
        },
        {
            key: "identify",
            value: function identify(userId) {
                var dryRun = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                pushToMatomo("setUserId", [
                    userId
                ], dryRun);
            }
        }
    ]);
    return MatomoProvider;
}();
var pushToMatomo = function pushToMatomo(operationName, args, dryRun) {
    if (dryRun) {
        var _console;
        (_console = console).log.apply(_console, [
            "Matomo pushInstruction:",
            operationName
        ].concat(_to_consumable_array(args)));
        return;
    }
    window._paq.push([
        operationName
    ].concat(_to_consumable_array(args)));
};
// src/tracking/index.ts
var Tracker = /*#__PURE__*/ function() {
    "use strict";
    function Tracker(providers) {
        _class_call_check(this, Tracker);
        this.providers = providers;
    }
    _create_class(Tracker, [
        {
            key: "sendEvent",
            value: function sendEvent(eventName, args, dryRun) {
                var providers = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : this.providers;
                providers.forEach(function(p) {
                    return p.sendEvent(eventName, args, dryRun);
                });
            }
        },
        {
            key: "pageView",
            value: function pageView(documentTitle, href, params, dryRun) {
                var providers = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.providers;
                providers.forEach(function(p) {
                    return p.pageView(documentTitle, href, params, dryRun);
                });
            }
        },
        {
            key: "identify",
            value: function identify(userId, dryRun) {
                var providers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.providers;
                providers.forEach(function(p) {
                    return p.identify(userId, dryRun);
                });
            }
        }
    ]);
    return Tracker;
}();
var matomoProvider = new MatomoProvider();
var gtagProvider = new GtagProvider();
var dataLayerProvider = new DataLayerProvider();
var tracker = new Tracker([
    matomoProvider,
    gtagProvider,
    dataLayerProvider
]);
var TrackingEvent = /* @__PURE__ */ function(TrackingEvent2) {
    TrackingEvent2["Audio"] = "audio";
    TrackingEvent2["CancelSubscription"] = "cancel_subscription";
    TrackingEvent2["Onboarding"] = "onboarding";
    TrackingEvent2["PostPurchaseOnboarding"] = "post_purchase_onboarding";
    TrackingEvent2["PostPurchaseSurvey"] = "post_purchase_survey";
    TrackingEvent2["Subscription"] = "subscription";
    TrackingEvent2["VanillaOnboarding"] = "vanilla_onboarding";
    return TrackingEvent2;
}(TrackingEvent || {});
export { AppSplitTestGroup, Environment, LandingSplitTestGroup, PRICING_GROUP_COOKIE, SPLIT_TEST_DIMENSION, SPLIT_TEST_GROUPS, TrackingEvent, calculateTestingGroup, dataLayerProvider, filterError, generateRandomUserId, getSwipeDirection, getTotalSplitTestGroups, gtagProvider, hashEmail, isFilteredError, isValidSplitTestGroup, matomoProvider, secondsToMinutes, simpleHashCode, trackTaboolaPixel, tracker };
